const GeoType = {
  point: 'point',
  linestring: 'linestring',
  polygon: 'polygon',
};

export default GeoType;
